import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useMobile } from '../hook/usePlatform';

const ScrollToTopButton:React.FC = () => {
  const location = useLocation();
  const [visible, setVisible] = useState<boolean>(false);
  const isMobile = useMobile();
  useEffect(() => {
    setVisible(location.pathname === '/');
  }, [location]);
  if (!visible) {
    return null;
  }
  return (
    <div
      style={{
        width: isMobile ? 44.5 : 56,
        height: isMobile ? 44.5 : 56,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'fixed',
        bottom: isMobile ? 70 : 100,
        backgroundColor: 'white',
        borderRadius: isMobile ? 18 : 21,
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: '#71777C',
        right: isMobile ? 12 : 24,
        cursor: 'pointer',
      }}
      onClick={() => {
        window.location.href = '/#top';
      }}
    >
      <img
        src="/svg/arrow.svg"
        alt="scrollToTop"
        width={isMobile ? 12 : 24}
        style={{ transform: 'rotate(180deg)' }}
      />
    </div>
  );
};

export default ScrollToTopButton;
